import { inject, Injectable } from '@angular/core';
import * as opportunitiesActions from './opportunities.actions';
import * as opportunitiesSelectors from './opportunities.selectors';
import { State } from './opportunities.reducer';
import { Store } from '@ngrx/store';
import { DynamicFormsManagementService } from '@wdx/clmi/ui';
import { StageCode } from '../../models/opportunities.model';
import {
    Opportunity,
    OPPORTUNITY_LOST_FORM_ID,
    OPPORTUNITY_WON_FORM_ID,
} from '@wdx/shared/utils';

@Injectable({ providedIn: 'root' })
export class OpportunitiesFacadeService {
    private dynamicFormsManagementService = inject(
        DynamicFormsManagementService,
    );
    private store = inject(Store) as Store<{
        opportunities: State;
    }>;

    public moveToStageAction(
        stageCode: string,
        opportunity: Opportunity,
    ): void {
        this.store.dispatch(
            opportunitiesActions.setActiveKanbanStage({
                stageCode,
            }),
        );

        if (stageCode === StageCode.Lost) {
            this.dynamicFormsManagementService.openDynamicFormModal({
                formId: OPPORTUNITY_LOST_FORM_ID,
                entityId: opportunity.id,
            });
            return;
        }
        if (stageCode === StageCode.Won) {
            this.dynamicFormsManagementService.openDynamicFormModal({
                formId: OPPORTUNITY_WON_FORM_ID,
                entityId: opportunity.id,
            });
            return;
        }
        this.store.dispatch(
            opportunitiesActions.moveToStage({
                opportunity: opportunity,
                fromStage: opportunity.stage?.code,
                toStage: stageCode,
            }),
        );
    }

    public getActiveMoveToStage() {
        return this.store.select(opportunitiesSelectors.getActiveMoveToStage);
    }
}
